import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { parseClickAnalytics, type AnalyticsRange, type ClickAnalytics } from "@/lib/analytics";

/** Agregados da pagina de Analytics (RPC get_click_analytics, RLS por tenant). */
export async function fetchClickAnalytics(range: AnalyticsRange): Promise<ClickAnalytics> {
  const { data, error } = await supabase.rpc("get_click_analytics", {
    p_start: range.start.toISOString(),
    p_end: range.end.toISOString(),
  });
  if (error) throw new Error(error.message);
  return parseClickAnalytics(data);
}

export function useClickAnalytics(range: AnalyticsRange | null) {
  return useQuery<ClickAnalytics, Error>({
    queryKey: ["click-analytics", range?.start.toISOString(), range?.end.toISOString()],
    queryFn: () => fetchClickAnalytics(range as AnalyticsRange),
    enabled: range !== null,
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  });
}
